import React, { useContext } from "react";
import { SiteContext } from "../context/SiteContext";
import { animationVersion, forcedAnimation } from "../util/animationVersion";
import PlayHotSeat from "./PlayHotSeat";
import PlayHotSeatCasino from "./PlayHotSeatCasino";

// Elige la sala del Hot Seat según la sala (salaId): 2D (canvas) por defecto y 3D solo donde se habilite.
// Mientras no se conoce la sala, PlayHotSeatCasino solo muestra la carga y no genera ningún sorteo.
export default function PlayHotSeatBySala() {
  const { salaId } = useContext(SiteContext);
  const version = forcedAnimation() || (salaId == null ? "2d" : animationVersion(salaId));
  return version === "3d" && salaId != null ? <PlayHotSeat /> : <PlayHotSeatCasino />;
}
